export default "__VITE_ASSET__BsItJx_Q__"